window.addEventListener("DOMContentLoaded", () => {
    const headerWrapper = document.querySelector(".header-section--wrapper");
  if (document.querySelector(".announcement_bar")) {
  // get the header wrapper (hidden by default)
  // get the close element
  const announcementBarCloseEl = document.querySelector(
    ".announcement-bar__close"
  );
  // get the announcement bar to close
  const announcementBar = document.querySelector(".announcement-bar--section");
  const announcementBarInner = document.querySelector(
    ".announcement-bar--section .announcement_bar"
  );
  // get the custom cookie expiry time - default set to 7
  if (announcementBar != null) {
  const announcementBarCookieExpiry =
    parseInt(announcementBarCloseEl.dataset.cookieExpiry) || 1;
  }
  // get the header
  const header = document.querySelector(".header-section");
  // get the main page wrapper
  let pageMainWrapper = document.querySelector('.page--wrapper');

  if (announcementBarCloseEl != null) {
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function checkCookie() {
      let hideAnnouncementBar = getCookie("announcementBarHide");
      if (hideAnnouncementBar != "") {
        announcementBar.classList.add("hidden");
      } else {
        announcementBar.classList.remove("hidden");
      }
    }

    // on page load, check if the cookie exists to hide the announcement bar
    checkCookie();

    // create a click event listener on the close element
    announcementBarCloseEl.addEventListener("click", () => {
      announcementBar.style.transform = `translateY(-${announcementBarInner.offsetHeight}px)`;
      header.style.top = "0px";
      setTimeout(() => {
        announcementBar.classList.add("hidden");
      }, 300);
      setCookie("announcementBarHide", true, announcementBarCookieExpiry);
    });
  }

  // function to calculate any differences in announcement bar height and change accordingly
  let updateHeaderTopStyle = () => {
    setTimeout(() => {
      header.style.transition = "all .3s";
    }, 100);
    let newAnnouncementBar = document.querySelector(
      ".announcement-bar--section .announcement_bar"
    );
    if (announcementBar != null) {
      if (!newAnnouncementBar.parentElement.classList.contains("hidden")) {
        header.style.top = `${newAnnouncementBar.offsetHeight - 1}px`;
        if (pageMainWrapper != null) { 
        // not needed for now 
        // pageMainWrapper.style.marginTop = `${newAnnouncementBar.offsetHeight * 2}px`
        }
      }
    }
  };

  headerWrapper.classList.remove("hidden");
  updateHeaderTopStyle();
  window.addEventListener("resize", () => {
    updateHeaderTopStyle();
  });
  } else {
      headerWrapper.classList.remove("hidden");
  }
});
